import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";

export const cityListLoader: LoaderFunction = async () => {

    const result = await axiosApi.get("/api/Cities/");

    return result.data
}